/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InternalModeInfoDto } from '../models';
// @ts-ignore
import type { LoginResponseDto } from '../models';
// @ts-ignore
import type { OnboardingDataDto } from '../models';
/**
 * RestAuthenticationApi - axios parameter creator
 * @export
 */
export const RestAuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary sending email with magic link
         * @param {string} username 
         * @param {OnboardingDataDto} onboardingDataDto 
         * @param {string} [token] 
         * @param {string} [internalModeParam] password internal mode
         * @param {string} [sourceApp] App source name from which the request is coming
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOtt: async (username: string, onboardingDataDto: OnboardingDataDto, token?: string, internalModeParam?: string, sourceApp?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('generateOtt', 'username', username)
            // verify required parameter 'onboardingDataDto' is not null or undefined
            assertParamExists('generateOtt', 'onboardingDataDto', onboardingDataDto)
            const localVarPath = `/ott/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (internalModeParam !== undefined) {
                localVarQueryParameter['internal-mode-param'] = internalModeParam;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (sourceApp != null) {
                localVarHeaderParameter['Source-App'] = String(sourceApp);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary check if internal mode is enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalModeInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/internal-mode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary login with magic link
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOtt: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('loginOtt', 'token', token)
            const localVarPath = `/login/ott`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAuthenticationApi - functional programming interface
 * @export
 */
export const RestAuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary sending email with magic link
         * @param {string} username 
         * @param {OnboardingDataDto} onboardingDataDto 
         * @param {string} [token] 
         * @param {string} [internalModeParam] password internal mode
         * @param {string} [sourceApp] App source name from which the request is coming
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOtt(username: string, onboardingDataDto: OnboardingDataDto, token?: string, internalModeParam?: string, sourceApp?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOtt(username, onboardingDataDto, token, internalModeParam, sourceApp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAuthenticationApi.generateOtt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary check if internal mode is enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInternalModeInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalModeInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInternalModeInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAuthenticationApi.getInternalModeInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary login with magic link
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginOtt(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginOtt(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAuthenticationApi.loginOtt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAuthenticationApi - factory interface
 * @export
 */
export const RestAuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary sending email with magic link
         * @param {string} username 
         * @param {OnboardingDataDto} onboardingDataDto 
         * @param {string} [token] 
         * @param {string} [internalModeParam] password internal mode
         * @param {string} [sourceApp] App source name from which the request is coming
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOtt(username: string, onboardingDataDto: OnboardingDataDto, token?: string, internalModeParam?: string, sourceApp?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateOtt(username, onboardingDataDto, token, internalModeParam, sourceApp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary check if internal mode is enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalModeInfo(options?: RawAxiosRequestConfig): AxiosPromise<InternalModeInfoDto> {
            return localVarFp.getInternalModeInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary login with magic link
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginOtt(token: string, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto> {
            return localVarFp.loginOtt(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAuthenticationApi - interface
 * @export
 * @interface RestAuthenticationApi
 */
export interface RestAuthenticationApiInterface {
    /**
     * 
     * @summary sending email with magic link
     * @param {string} username 
     * @param {OnboardingDataDto} onboardingDataDto 
     * @param {string} [token] 
     * @param {string} [internalModeParam] password internal mode
     * @param {string} [sourceApp] App source name from which the request is coming
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthenticationApiInterface
     */
    generateOtt(username: string, onboardingDataDto: OnboardingDataDto, token?: string, internalModeParam?: string, sourceApp?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary check if internal mode is enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthenticationApiInterface
     */
    getInternalModeInfo(options?: RawAxiosRequestConfig): AxiosPromise<InternalModeInfoDto>;

    /**
     * 
     * @summary login with magic link
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthenticationApiInterface
     */
    loginOtt(token: string, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponseDto>;

}

/**
 * RestAuthenticationApi - object-oriented interface
 * @export
 * @class RestAuthenticationApi
 * @extends {BaseAPI}
 */
export class RestAuthenticationApi extends BaseAPI implements RestAuthenticationApiInterface {
    /**
     * 
     * @summary sending email with magic link
     * @param {string} username 
     * @param {OnboardingDataDto} onboardingDataDto 
     * @param {string} [token] 
     * @param {string} [internalModeParam] password internal mode
     * @param {string} [sourceApp] App source name from which the request is coming
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthenticationApi
     */
    public generateOtt(username: string, onboardingDataDto: OnboardingDataDto, token?: string, internalModeParam?: string, sourceApp?: string, options?: RawAxiosRequestConfig) {
        return RestAuthenticationApiFp(this.configuration).generateOtt(username, onboardingDataDto, token, internalModeParam, sourceApp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary check if internal mode is enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthenticationApi
     */
    public getInternalModeInfo(options?: RawAxiosRequestConfig) {
        return RestAuthenticationApiFp(this.configuration).getInternalModeInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary login with magic link
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthenticationApi
     */
    public loginOtt(token: string, options?: RawAxiosRequestConfig) {
        return RestAuthenticationApiFp(this.configuration).loginOtt(token, options).then((request) => request(this.axios, this.basePath));
    }
}

